import { useCallback, useState } from 'react';
import { useShell } from '../../shell-context.js';
import { GoodsReceiptDetailView } from './GoodsReceiptDetailView.js';
import { GoodsReceiptList } from './GoodsReceiptList.js';
import { NewGoodsReceipt } from './NewGoodsReceipt.js';
import { GRN_PATH, type GrnRoute, grnPath, purchaseOrderPath } from './orders.js';
import type { GoodsReceiptSource } from './source.js';

export interface GoodsReceiptsScreenProps {
  source: GoodsReceiptSource;
  /** Sorgu dizesinden (`?id=…`, `?new=1&po=…`; `grnRoute`). */
  route: GrnRoute;
  message?: string | null;
}

/**
 * Goods Receipt (M12c Task 17; `gemi-satin-alma.jpeg` 6, `satin-alma-akisi.jpeg` "Delivery &
 * GRN"): liste, GRN kartı ve gemide yeni GRN formu. Gemide yazılır, ofiste salt okunur (ADR 0026
 * §1; ADR 0040).
 */
export function GoodsReceiptsScreen({ source, route, message = null }: GoodsReceiptsScreenProps) {
  const shell = useShell();
  const [notice, setNotice] = useState<string | null>(message);
  const go = useCallback(
    (next: GrnRoute, text: string | null = null) => {
      setNotice(text);
      shell?.navigate(grnPath(next));
    },
    [shell],
  );
  const onDone = useCallback((id: string, text: string) => go({ view: 'detail', id }, text), [go]);
  const editor = source.editor;

  if (route.view === 'new' && editor) {
    return (
      <NewGoodsReceipt
        editor={editor}
        orderId={route.orderId}
        onDone={onDone}
        onCancel={() => go({ view: 'list' })}
      />
    );
  }
  if (route.view === 'detail') {
    return (
      <GoodsReceiptDetailView
        key={route.id}
        source={source}
        id={route.id}
        message={notice}
        onBack={() => go({ view: 'list' })}
        onOpenOrder={(id) =>
          shell?.navigate(purchaseOrderPath({ view: 'detail', id, tab: 'receipts' }))
        }
      />
    );
  }
  return (
    <GoodsReceiptList
      source={source}
      onOpen={(id) => go({ view: 'detail', id })}
      onNew={() => go({ view: 'new', orderId: null })}
    />
  );
}

export { GRN_PATH };
